import React from 'react';
import { IMAGES } from '../mock';
import { Calculator, Sigma, GitBranch, Triangle, Dices, FunctionSquare, Box } from 'lucide-react';

const ICONS = [Calculator, Sigma, GitBranch, Triangle, Dices, FunctionSquare, Box];

export default function Courses() {
  return (
    <section className="gradient-bg-light py-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[#a020c9] tracking-widest text-sm font-semibold uppercase">— Cursos Principais —</p>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#7a1fb0] mt-2">Explore o conteúdo completo</h2>
          <div className="h-1 w-24 bg-[#ec2fd2] mx-auto mt-4 rounded"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {IMAGES.courses.map((c, i) => {
            const Icon = ICONS[i] || Calculator;
            return (
              <div key={i} className="card-course">
                <div className="card-thumb">
                  <div className="flex flex-col items-center gap-3">
                    <Icon size={48} />
                    <span>{c.title.replace('Curso de ', '').replace(/"/g, '')}</span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-heading font-bold text-lg text-[#2b1039] mb-2">{c.title}</h3>
                  <p className="text-sm text-[#5a3a6b] leading-relaxed">{c.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
